import Vue from 'vue';
import VueRouter from 'vue-router';
import Auth from './auth';
import Dashboard from './dashboard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/auth',
  },
  {
    path: '*',
    redirect: '/auth',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.addRoutes([
  Auth,
  Dashboard,
]);

export default router;
